export default "__VITE_ASSET__CkVtEnlh__"